import { useContext } from 'react'
import { useMutation } from 'react-query'

import { AuthContext } from '@auth/auth.context'
import { signOut } from '@auth/auth.logic'
import { UseSignOut } from '@auth/auth.types'
import { useCareProvider } from '@providers/providers.hooks'

export const useAuth = () => {
  return useContext(AuthContext)
}

export const useSignOut: UseSignOut = ({ onSuccess, ...options } = {}) => {
  return useMutation(signOut, { onSuccess, ...options })
}

export const useNiloId = () => {
    const { careProvider } = useCareProvider()
  
    const getConfig = (queryParams: object = {}) => {
      const { origin, protocol } = window.location
      const niloIdDomain = process.env.NEXT_PUBLIC_NILO_ID_DOMAIN
      const prefix = careProvider?.domainPrefix ? `${careProvider?.domainPrefix}.` : ''
      const niloIdUrl = `${protocol}//${prefix}${niloIdDomain}`
      const queries = Object.entries(queryParams).map(([key, value]) => `${key}=${value}`)
      return { redirectUrl: origin, niloIdUrl, queries }
    }
  
    const redirectToLogin = (queryParams: object = {}) => {
      const { niloIdUrl, redirectUrl, queries } = getConfig(queryParams)
      window.location.href = `${niloIdUrl}?redirectUrl=${redirectUrl}&${queries.join('&')}`
    }
  
    const logout = (queryParams: object = {}) => {
      const { niloIdUrl, redirectUrl, queries } = getConfig(queryParams)
      window.location.href = `${niloIdUrl}/logout?redirectUrl=${redirectUrl}&${queries.join('&')}`
    }
  
    return { redirectToLogin, logout }
}
